<template>
	<div class="filter-category filter-box">
		<div
			v-if="showSubCategories && category.current && category.current.level > 1"
			class="filter-category-back"
			@click="navigate(0)"
		>
			{{ 'Alla kategorier' }}
		</div>
		<div class="filter-category-header">
			<template v-if="showSubCategories && category.current && category.current.level > 1">
				<h3>
					<span class="categoryimg" :style="categoryImgStyle(category.current.icon)" />
					<span class="filter-box-value-text"> {{ category.current.name }} </span>
				</h3>
				<span v-if="category.current.productCount !== undefined" class="filter-box-value-count">
					({{ category.current.productCount }})
				</span>
			</template>
			<h3 v-else>
				Kategorier
			</h3>
		</div>
		<div>
			<loading-spinner v-if="category.loading"/>
			<span
				v-else-if="! category.current"
				class="placeholder"
			>
				Ange söktext för att filtrera
			</span>
			<span
				v-else-if="category.current.level === 1 && categoryChildrenLength === 0"
				class="placeholder"
			>
				Inga kategorier
			</span>
			<span
				v-else-if="showSubCategories && categoryChildrenLength === 0"
				class="placeholder"
			>
				Inga underkategorier
			</span>
			<!-- This generates checkboxes on first level, used for campaigns and member offers -->
			<ul v-else-if="! showSubCategories">
				<li
					v-for="child in (showAll ? category.tree.children : category.tree.children.slice(0, showLimit))"
					class="category-filter"
					:key="child.id"
				>
					<checkbox
						v-model="categoryFilterMap[child.id]"
						labelSlot
						:small="isDesktop"
						@input="ev => toggleCategory(ev, child.id)"
					>
						<span class="categoryimg" :style="categoryImgStyle(child.icon)" />
						{{ child.name }}
						<span v-if="child.productCount !== undefined" class="checkbox-count">
							({{ child.productCount }})
						</span>
					</checkbox>
				</li>
			</ul>
			<ul v-else-if="category.current.level === 1 && categoryChildrenLength > 0">
				<li
					v-for="child in (showAll ? category.current.children : category.current.children.slice(0, showLimit))"
					:key="child.id"
				>
					<a class="category-filter" @click="navigate(child.id)">
						<span class="categoryimg" :style="categoryImgStyle(child.icon)" />
						<span class="filter-box-value-text"> {{ child.name }} </span>
					</a>
					<span v-if="child.productCount !== undefined" class="filter-box-value-count">
						({{ child.productCount }})
					</span>
				</li>
			</ul>
			<template v-else>
				<checkbox
					v-for="child in (showAll ? category.current.children : category.current.children.slice(0, showLimit))"
					:key="child.id"
					v-model="categoryFilterMap[child.id]"
					:small="isDesktop"
					:label="child.name"
					:filterCount="child.productCount"
					@input="ev => toggleCategory(ev, child.id)"
				/>
			</template>
			<a
				v-if="category.current && categoryChildrenLength > showLimit"
				:class="{ small: isDesktop }"
				@click="showAll = ! showAll"
			>
				{{ showAll ? 'Visa färre' : 'Visa fler' }}
			</a>
		</div>
		<hr />
	</div>
</template>

<script>
import { convertToCdnUrl } from 'utils';
import mq from 'mediaQuery';

export default {
	props: {
		category: {
			type: Object,
		},
		categoryFilterMap: {
			type: Object,
		},
		showSubCategories: {
			type: Boolean,
			default: true,
		},
	},
	data () {
		return {
			showLimit: 15,
			showAll: false,
			mq,
		};
	},
	computed: {
		categoryChildrenLength () {
			return this.category.current.children ? this.category.current.children.length : 0;
		},
		isDesktop () {
			return mq.current > mq.md;
		},
	},
	methods: {
		categoryImgStyle (icon) {
			return `background-image: url(${convertToCdnUrl('/api/dynimg/category/' + icon + '/1A1A1D')})`;
		},
		navigate (id) {
			for (const i in this.category.current.children) {
				this.toggleCategory(false, this.category.current.children[i].id);
			}
			this.$emit('updateSearchTree', id);
		},
		toggleCategory (ev, id) {
			const enabled = !! ev;
			this.$emit('updateSearchCategory', id, enabled);
		},
	},
};
</script>
